import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import ProductDetailTab from './ProductDetailTab';
import useDetailHandler from '../../hooks/useDetailHandler';
import { productPropertiesType, productType } from '../../types';
import './_styles_/ProductRow.css';
import { onActionKey } from '../../utils';
import { getAllProductTypes, getProductType } from '../../utils/ProductTypes';
import { getScope, getAllScopes } from '../../utils/Scopes';

export const getValueMapping = (t) => ({
    active: [
        {
            from: true,
            to: t('misc.yes'),
        },
        {
            from: false,
            to: t('misc.no'),
        },
    ],
    productType: getAllProductTypes().map((typeOfProduct) => ({ from: typeOfProduct.serverType, to: typeOfProduct.translate(t) })),
    scope: getAllScopes().map((scope) => ({ from: scope.serverType, to: scope.translate(t) })),
});

ProductRow.propTypes = {
    product: productType.isRequired,
    productProps: productPropertiesType.isRequired,
    activeProductType: PropTypes.string.isRequired,
};

function ProductRow(props) {
    const { t } = useTranslation();
    const { product, productProps, activeProductType } = props;
    const { isDetailVisible, toggleDetail } = useDetailHandler(product.productId);
    const iconStyle = product.iconColor ? { color: product.iconColor } : {};
    return (
        <>
            <div className="rich-list-row product-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="product-header--values--icon">
                    {product.iconSymbol && <FontAwesomeIcon icon={product.iconSymbol} style={iconStyle} />}
                </div>
                <div className="product-header--values--product-id">{product.productId}</div>
                {activeProductType === 'ALL' && (
                    <div className="product-header--values--product-type">{getProductType(product.productType).translate(t)}</div>
                )}
                {activeProductType !== 'ENERGY' && (
                    <div className="product-header--values--scope">{product.scope && getScope(product.scope).translate(t)}</div>
                )}
                <div className="product-header--values--name">{product.name}</div>
                {activeProductType === 'SECURITY' && (
                    <div className="product-header--values--isin-code">{product.isinCode}</div>
                )}
                <div className="product-header--values--active">{product.active ? t('misc.yes') : t('misc.no')}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && <ProductDetailTab product={product} productProps={productProps} activeProductType={activeProductType} />}
        </>
    );
}

export default ProductRow;
